// Microcopys de nudging para aumentar ticket promedio
// Estos mensajes se pueden usar dinámicamente basados en el tipo de producto

export const nudgingMessages = {
  wine: [
    "Va increíble con nuestros quesos artesanales",
    "Perfecto para compartir con una tabla de embutidos",
    "Ideal acompañado de nuestras tapas de autor",
    "Marida excepcionalmente con platos de pescado"
  ],
  cocktail: [
    "Prueba también nuestros aperitivos",
    "Ideal para acompañar con algo ligero",
    "Combina perfecto con nuestras tapas",
    "¿Has probado nuestros snacks de la casa?"
  ],
  food: [
    "¿Qué tal un vino para acompañar?",
    "Perfecto para compartir, ¿agregamos algo más?",
    "Ideal con una copa de nuestra selección",
    "Va increíble con nuestros cócteles"
  ],
  default: [
    "Nuestra recomendación del chef",
    "Muy popular entre nuestros clientes",
    "Ideal para compartir",
    "Una experiencia única"
  ]
};

// Función para obtener un mensaje aleatorio basado en el tipo de producto
export const getNudgingMessage = (productType = 'default', productName = '') => {
  const messages = nudgingMessages[productType] || nudgingMessages.default;
  
  // Si el producto tiene un pairingSuggestion, usarlo primero
  // Esto se maneja en el componente Card
  
  // Retornar un mensaje aleatorio para variedad
  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
};

// Función para detectar el tipo de producto basado en nombre o categoría
export const detectProductType = (productName = '', categoryName = '') => {
  const name = productName.toLowerCase();
  const category = categoryName.toLowerCase();
  
  if (name.includes('vino') || name.includes('wine') || category.includes('vino') || category.includes('wine')) {
    return 'wine';
  }
  if (name.includes('cóctel') || name.includes('cocktail') || name.includes('coctel') || category.includes('cóctel') || category.includes('cocktail')) {
    return 'cocktail';
  }
  if (name.includes('comida') || name.includes('tapa') || name.includes('plato') || category.includes('comida') || category.includes('food')) {
    return 'food';
  }
  
  return 'default';
};
